var _rect, _path, _path2, _path3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodaysRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    fill: "#FDF2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6184 30.0466C16.2751 29.6968 16.2751 29.1365 16.6184 28.7868C16.9708 28.4278 17.5492 28.4278 17.9016 28.7868L19.6 30.5167V23.9C19.6 23.4029 20.0029 23 20.5 23C20.9971 23 21.4 23.4029 21.4 23.9V30.5167L23.0984 28.7868C23.4508 28.4278 24.0292 28.4278 24.3816 28.7868C24.7249 29.1365 24.7249 29.6968 24.3816 30.0466L20.5 34L16.6184 30.0466Z",
    fill: "#E87A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3216 23.5385C30.6875 23.8773 30.6875 24.456 30.3216 24.7948C29.9934 25.0987 29.4866 25.0987 29.1584 24.7948L27.4 23.1667V29.1C27.4 29.5971 26.9971 30 26.5 30C26.0029 30 25.6 29.5971 25.6 29.1V23.1667L23.8416 24.7948C23.5134 25.0987 23.0066 25.0987 22.6784 24.7948C22.3125 24.456 22.3125 23.8773 22.6784 23.5385L26.5 20L30.3216 23.5385Z",
    fill: "#E87A46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0143 30.1051C14.7253 30.5518 14.1387 30.6963 13.6752 30.4351L9 27.8C8.4 27.4 8 26.8 8 26.1V13.9C8 13.2 8.4 12.5 9 12.2L19 6.3C19.3 6.1 19.6 6 20 6C20.4 6 20.7 6.1 21 6.3L31 12.2C31.6 12.6 32 13.2 32 13.9V19C32 19.5523 31.5523 20 31 20C30.4477 20 30 19.5523 30 19V13.9L20 8L10 13.9V26.1L14.6568 28.6779C15.1669 28.9602 15.3311 29.6156 15.0143 30.1051Z",
    fill: "#E87A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#E87A46",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodaysRequest);
export default __webpack_public_path__ + "static/media/TodaysRequest.d633a5a558a5e74aa001b6a9466edccd.svg";
export { ForwardRef as ReactComponent };